/**
 * Skobo Permission class
 * @category Models
 * @subcategory Documents
 * @class Documents
 * @name Permission
 */

class Permission {
  myPermission = nctStatusEnPermissionDefinition.NONE;
  id = undefined;
  name = "";

  constructor(graphPermission, id, name, myPermission) {
    if (id) {
      this.id = id;
    }
    if (name) {
      this.name = name;
    }

    if (myPermission) {
      this.myPermission = myPermission;
    }

    if (graphPermission) {
      this.id = graphPermission.id;

      if (graphPermission.roles) {
        this.myPermission = Permission.graphPermissionRolesArray2nctPermission(graphPermission.roles);
      } else {
        this.myPermission = nctStatusEnPermissionDefinition.NONE;
      }

      this.name = graphPermission.grantedToV2
        ? graphPermission.grantedToV2.user
          ? graphPermission.grantedToV2.user.displayName
          : graphPermission.grantedToV2.siteUser
            ? graphPermission.grantedToV2.siteUser.displayName
            : ""
        : "";
    }
  }

  // Getters
  /**
   * Is permission either owner or write
   * @returns {boolean} Return true if permission role is owner or write
   */
  get hasEditPermission() {
    return (
      this.myPermission === nctStatusEnPermissionDefinition.OWNER ||
      this.myPermission === nctStatusEnPermissionDefinition.WRITE
    );
  }

  /**
   * Is permission owner
   * @returns {boolean} Return true if permission role is owner
   */
  get hasOwnerPermission() {
    return this.myPermission === nctStatusEnPermissionDefinition.OWNER;
  }

  /**
   * Has no permissions at all
   * @returns {boolean} Return true if permission role is none
   */
  get hasNoPermission() {
    return this.myPermission === nctStatusEnPermissionDefinition.NONE;
  }

  /**
   * Expose status enum
   * @returns {object} Status enum
   */
  static get nctPermission() {
    return nctStatusEnPermissionDefinition;
  }

  //
  //
  // Methods

  // Static Methods
  static graphPermissionRolesArray2nctPermission(graphStatusArray) {
    if (graphStatusArray.indexOf("owner") > -1) {
      return nctStatusEnPermissionDefinition.OWNER;
    }

    if (graphStatusArray.indexOf("write") > -1) {
      return nctStatusEnPermissionDefinition.WRITE;
    }

    if (graphStatusArray.indexOf("read") > -1) {
      return nctStatusEnPermissionDefinition.READ;
    }

    return nctStatusEnPermissionDefinition.NONE;
  }

  static generateGraphRequestFromDriveItem(driveId, itemId) {
    if (driveId && itemId) {
      return {
        id: driveId + "|" + itemId,
        method: "GET",
        url: `/drives/${driveId}/items/${itemId}/permissions`
      };
    }
  }
}

const nctStatusEnPermissionDefinition = {
  NONE: 0,
  READ: 1,
  WRITE: 2,
  OWNER: 3
};

export default Permission;
